import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@chakra-ui/react';
import { FaArrowRightToBracket } from 'react-icons/fa6';
export const LoginButton = () => {
    const { loginWithRedirect } = useAuth0();
    const handleLogin = async () => {
        await loginWithRedirect({
            appState: {
                returnTo: '/',
            },
        });
    };
    return (_jsxs(Button, { variant: "ghost", color: "#FFF", _hover: { bg: 'whiteAlpha.200' }, onClick: handleLogin, size: "md", children: [_jsx(FaArrowRightToBracket, {}), "Log In"] }));
};
